"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Caption2", {
    enumerable: true,
    get: function() {
        return Caption2;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useCaption2Stylesstyles = require("./useCaption2Styles.styles");
const Caption2 = (0, _createPreset.createPreset)({
    useStyles: _useCaption2Stylesstyles.useCaption2Styles,
    className: _useCaption2Stylesstyles.caption2ClassNames.root,
    displayName: 'Caption2'
});
